import styled from 'styled-components'

export const HeroHeaderImageWrapper = styled.header`
        background-image: url(https://github.com/sawanori/dooyaji_ec/blob/master/src/images/top_message.jpg?raw=true);
        
        background-size: cover;
        background-position: center top;
        width: 100%;
        height: 70vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        h1 {
        color:#fff;
        }
`